export default __webpack_public_path__ + "static/media/glass_small.ac1e7686.svg";